/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Row, Col,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function BoardNumberFieldset(props) {
  const { arrayHelpers, t } = props;

  const handleAddBoardNumber = () => {
    arrayHelpers.push({ label: 'Search' });
  };

  const handleAddVisibleNumber = () => {
    arrayHelpers.push({ label: 'Visible Number' });
  };

  const handleAddManufacturerPartNumber = () => {
    arrayHelpers.push({ label: 'Manufacturer Part Number' });
  };

  const jsx = (
    <FormikConsumer>
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values,
      }) => (
        <div>
          <Button color="primary" onClick={() => handleAddBoardNumber(arrayHelpers)} className="btn-sm btn-soft-primary mt-3 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Searchable Term')}
          </Button>
          <Button color="primary" onClick={() => handleAddVisibleNumber(arrayHelpers)} className="btn-sm btn-soft-primary mt-3 mb-3 ms-3">
            <span className="bx bx-plus" />
            {props.t('Add Visible Number')}
          </Button>
          <br />
          <Button color="primary" onClick={() => handleAddManufacturerPartNumber(arrayHelpers)} className="btn-sm btn-soft-primary mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Manufacturer Part Number')}
          </Button>
          {errors.identifiers !== undefined && typeof errors.identifiers === 'string' && (
            <ErrorMessage
              name="boardNumbers"
              component="div"
              className="alert alert-danger fade show mt-2 mb-3"
            />
          )}
          {values && values.boardNumbers && values.boardNumbers.map((num, index) => (
            <Row key={num.id}>
              <Col sm="6" className="mb-3" key={index}>
                <InputGroup>
                  <Field name={`boardNumbers[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                  <Button
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                    color="danger"
                    className="btn-soft-danger"
                  >
                    <span className="mdi mdi-close-thick" />
                  </Button>
                </InputGroup>
                <ErrorMessage
                  name={`boardNumbers[${index}].label`}
                  component="div"
                  className="text-danger pt-1"
                />
              </Col>

              <Col sm="6">
                <Field name={`boardNumbers[${index}].value`} type="text" className="form-control" placeholder={t('Value')} />
              </Col>
            </Row>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

BoardNumberFieldset.defaultProps = {
  t: (x) => (x),
};

BoardNumberFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(BoardNumberFieldset));
